import { IrisDmsContentPaginationI } from './IrisDmsContentPagination';
import { IrisQueryParamsOrderBy } from '@iris/api-query';
import { DmsFilesGridColName } from './IrisDmsGridTypes';

export const defaultContentPagination: IrisDmsContentPaginationI = {
  offset: 0,
  limit: 25,
  orderBy: [new IrisQueryParamsOrderBy({ name: DmsFilesGridColName.UpdatedOn, value: 'asc' })],
};
